import { render, staticRenderFns } from "./levelUpModal.vue?vue&type=template&id=3831360b&scoped=true&lang=pug&"
import script from "./levelUpModal.vue?vue&type=script&lang=js&"
export * from "./levelUpModal.vue?vue&type=script&lang=js&"
import style0 from "./levelUpModal.vue?vue&type=style&index=0&id=3831360b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831360b",
  null
  
)

export default component.exports